import axios from "axios";
import { LFRequest } from "@cyanmoon8/lfcloud";

// 网络配置
const apiHost = "https://api-func.lfwellness.cn:9999"; // 接口地址

// 网络实例
const instance = axios.create();

// 登录失败code表
const LogoutCodeList = [401];

// 封装后的请求实例
const instanceConfig = {
  apiHost,
  instance,
};


export const lfRequest = new LFRequest(
  instanceConfig,
  { // 请求拦截
    success: (config) => {
     
	  // 在此写请求拦截的逻辑代码
    },
    fail: (err) => {},
  },
  { // 响应拦截
    success: (res) => {},
    fail: (err) => {
	  // 在此写响应拦截的逻辑代码
      let errCode = err.response.status;
      let errMsg = err.response.data.message;

      if (errCode && errMsg) {
        // MessageOnce.error(errMsg);
      }
      if (LogoutCodeList.includes(errCode)) {
        
      }
    },
  }
);
